import { Badge } from "primereact/badge";
import { store } from "../../../stateManagement/store";
import { setExpandedKeys } from "../../../stateManagement/reducers/ObjectsOnMapPointInfoSlice";
import { getIndorImageSrc } from "../../../features";

export function objectsInfoAccordionHeaderTemplate(roadAndPath: string) {
    let roadName, pathName;
    if (roadAndPath.includes('/')) {
        ([roadName, pathName] = roadAndPath.split('/'))
    } else {
        roadName = roadAndPath
    }

    return (
        <div className="objects-accordion-header-text-div">
            <strong>{roadName}</strong>
            {pathName && <span>{pathName}</span>}
        </div>
    )
}

function toggleGroup(event: any, options: any, roadAndPath: string) {
    const { onTogglerClick, props, expanded } = options ?? {}
    onTogglerClick.call(this, event)
    const expandedKeys = store.getState().objectsOnMapPointInfo.expandedKeys
    const newExpandedKeys = { ...expandedKeys }
    newExpandedKeys[roadAndPath] = { ...props.expandedKeys, [props.node.key]: (!expanded ? true : undefined) }
    store.dispatch(setExpandedKeys(newExpandedKeys))
}


export function objectTypesTreeNodeTemplate(node: any, options: any) {
    const { label, isParentNode, imageIndex, imageSrc, children } = node ?? {}
    const { className } = options ?? {}
    const onClickFunction = (event: any) => toggleGroup(event, options, children[0]?.roadAndPath)
    return (
        <div className="objects-tree-node hover:text-primary" onClick={isParentNode ? onClickFunction : undefined}>
            {imageSrc ?
                <img className="node-image" src={imageSrc} />
                :
                <img className="node-image" src={getIndorImageSrc(imageIndex)} />
            }
            <span className={className}>{label}</span>
            {isParentNode && <Badge className="number-of-objects-badge" value={children?.length}></Badge>}
        </div>
    )
}